import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../api/axios';

export default function CbkCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Check for error
    const errorCode = searchParams.get('ErrorCode');
    if (errorCode) {
      navigate('/dashboard/subscription?payment=failed', { replace: true });
      return;
    }

    // Collect all query params to send to backend
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    api.post('/subscription/verify-cbk', params)
      .then((res) => {
        if (res.data.status === 'success') {
          navigate('/dashboard/subscription?payment=success', { replace: true });
        } else {
          navigate('/dashboard/subscription?payment=failed', { replace: true });
        }
      })
      .catch(() => {
        navigate('/dashboard/subscription?payment=failed', { replace: true });
      });
  }, []);

  return (
    <div className="empty-state">
      <p style={{ fontSize: 16 }}>Processing KNET payment...</p>
    </div>
  );
}
